'use strict';

export default class ProductCard {
	constructor(element) {
		this.element = element
		if(!element) return false;
		element.classList.add('is-inited');

		this.slider = this.element.querySelector("[data-product-card-slider]");

		this.mouseenter();
		this.mouseleave();
		this.initSlider();
	}

	initSlider() {
		if (!this.slider) return;
		$(this.slider).slick({
			dots: true,
		    dotsClass: "product-card-slider__dots",
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    infinite: false,
		    prevArrow: $(this.element).find('.product-card-slider__prev'),
		    nextArrow: $(this.element).find('.product-card-slider__next'),
		});
	}

	mouseenter(){
		this.element.addEventListener('mouseenter',()=>{
			this.element.style.height = this.element.offsetHeight + 'px';
			this.element.classList.add("hover");
		});
	}
	mouseleave(){
		this.element.addEventListener('mouseleave',()=>{
			this.element.classList.remove("hover");
			this.element.style.height = ''
		});
	}
}
